import { render, staticRenderFns } from "./Treated.vue?vue&type=template&id=5a79eff4&scoped=true"
import script from "./Treated.vue?vue&type=script&lang=js"
export * from "./Treated.vue?vue&type=script&lang=js"
import style0 from "./Treated.vue?vue&type=style&index=0&id=5a79eff4&prod&scoped=true&lang=css"
import style1 from "./Treated.vue?vue&type=style&index=1&id=5a79eff4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a79eff4",
  null
  
)

export default component.exports